import React from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { LOADING_STATUS } from '../../../common/constants';

type CreateReportCardProps = {
  reportingYear: number;
  notes: string;
  yearOptions: number[];
  createStatus: LOADING_STATUS;
  onReportingYearChange: (year: number) => void;
  onNotesChange: (value: string) => void;
  onCreate: () => void;
};

function CreateReportCard({
  reportingYear,
  notes,
  yearOptions,
  createStatus,
  onReportingYearChange,
  onNotesChange,
  onCreate,
}: CreateReportCardProps) {
  return (
    <Card className="bg-white border shadow-none p-24 mb-24">
      <h5 className="mb-16">Luo uusi DAC7-raportti</h5>
      <p className="text-muted mb-16">
        DAC7-raportti sisältää tiedot vuokranantajista ja heidän
        vuokratuloistaan Suomen veroviranomaisille (Ilmoitin-palvelu).
      </p>
      <Row>
        <Col md={3}>
          <Form.Group className="mb-16">
            <Form.Label>Raportointivuosi</Form.Label>
            <Form.Select
              value={reportingYear}
              onChange={e => onReportingYearChange(Number(e.target.value))}
            >
              {yearOptions.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-16">
            <Form.Label>Muistiinpanot (valinnainen)</Form.Label>
            <Form.Control
              type="text"
              value={notes}
              onChange={e => onNotesChange(e.target.value)}
              placeholder="Lisää muistiinpanoja raporttiin..."
            />
          </Form.Group>
        </Col>
        <Col md={3} className="d-flex align-items-end">
          <Button
            variant="primary"
            onClick={onCreate}
            disabled={createStatus === LOADING_STATUS.LOADING}
            className="mb-16 w-100"
          >
            {createStatus === LOADING_STATUS.LOADING ? (
              <>
                <Spinner size="sm" className="me-2" />
                Luodaan...
              </>
            ) : (
              'Luo raportti'
            )}
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

export default CreateReportCard;
